import React from 'react';

const Menu404 = () => (
    <h1 className="text-danger"> Sucedio algún inconceniente en la autenticación <small>Por favor validar con Registro o CCESEN</small></h1>
)

export default Menu404